const applicationConfig = {
    CONSUMER_CF_DISTRO: process.env.__VUE_APP_CONSUMER_CF_DISTRO__,
    GOOGLE_PLACES_API_KEY: process.env.__VUE_APP_GOOGLE_PLACES_API_KEY__,
    ANALYTICS_SESSION_TIMEOUT_MINUTES: 30,
    SAVED_SESSION_TIMEOUT_DAYS: 45,
    COOKIE_PATH: "/",
    CURRENT_ENVIRONMENT: process.env.__VUE_APP_CURRENT_ENVIRONMENT__, // "Localhost", "Dev", "QA", and "Prod"
    HERITAGE_FUNNEL: process.env.__VUE_APP_HERITAGE_FUNNEL__,
    SAFELITE_HOP: process.env.__VUE_APP_SAFELITE_HOP__,
    APPLICATION_NAME: "FixMyGlass",
    ANALYTICS_APPLICATION_NAME: "FixMyGlassNextGen",
    APPLICATION_ABBREVIATION: "fmg",
    PAGE_QUERYSTRING: "fmgPage",
    SITE_ENTRY_TRIGGER_VALUE: "FixMyGlass",
    CASH_PARENT_ACCOUNT_NUMBER: 167132,
    CASH_DEFAULT_BILL_TO_ACCOUNT_NUMBER: "87291",
    MY_ACCOUNT: process.env.__VUE_APP_MY_ACCOUNT__,
    PIA_RESPONSE_URL:
        location.protocol + "//" + location.host + "/fmg/payment-pia-return?src=concept-funnel",
    PIA_CANCEL_URL:
        location.protocol + "//" + location.host + "/fmg/payment-method?src=concept-funnel",
    PIA_ERROR_URL:
        location.protocol + "//" + location.host + "/fmg/payment-pia-return?src=concept-funnel",
    CONFIRMATION_URL: location.protocol + "//" + location.host + "/fmg/confirmation",
    PIA_ADYEN_RETURN_URL: location.protocol + "//" + location.host + "/fmg/virtual/payment/return",
    GOOGLE_CALENDAR: "https://www.google.com/calendar/render?action=TEMPLATE",
    YAHOO_CALENDAR: "https://calendar.yahoo.com/?v=60",
    OUTLOOK_CALENDAR:
        "https://outlook.office.com/calendar/deeplink/compose?path=/calendar/action/compose&rru=addevent",
    FRONTEND_LOGGER_PATH: "/analytics/api/v1/logging",
    AFFILIATE_COOKIE_CONTAINING_NAME: "_Track",
    COOKIE_NAME_LENGTH_MAX_LIMIT: 44,
    SESSION_TIMEOUT_MINUTES: process.env.__VUE_APP_SESSION_TIMEOUT_MINUTES__,
    SESSION_EXPIRATION_INTERVAL_CHECK_MILLISECONDS:
        process.env.__VUE_APP_SESSION_EXPIRATION_INTERVAL_CHECK_MILLISECONDS__,
    RETURN_USER_PAGE: "/fmg/return-user",
    ADYEN_CLIENT_KEY: process.env.__VUE_APP_ADYEN_CLIENT_KEY__,
    ADYEN_ENVIRONMENT: process.env.__VUE_APP_ADYEN_ENVIRONMENT__,
};

export { applicationConfig };
